module.exports = __webpack_public_path__ + "img/05.57d03a91.png";